import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { IBehaelter } from '../_interfaces/behaelter';

import { BehaelterService } from '../_services/behaelter.service';
import { HerstellerService } from '../_services/hersteller.service';
import { IHersteller } from '../_interfaces/hersteller';

@Pipe({
  name: 'hersteller'
})
export class HerstellerPipe implements PipeTransform {
  constructor(
    private herstellerService: HerstellerService,
  ) { }

  transform(value: unknown, ...args: unknown[]): unknown {
    //console.log("HerstellerPipe.transform() value: ", value);
    if(value == null) return of('');

    return this.herstellerService.getHersteller(value as string)
    .pipe(
      map((hersteller: IHersteller) => {
        //console.log("HerstellerPipe.transform(): hersteller:", hersteller);
        return hersteller.bezeichnung
      })
      , catchError(error => {
        //console.error("HerstellerPipe.transform()error: ", error);
        return of('');
      })
    );

  }

}

